module.exports = __webpack_public_path__ + "static/media/banner1.bce98a95.png";